import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as sourceUtil from "./sourceUtil";

export function getServiceAdminUrl(serviceUrl) {
  let url = serviceUrl.replace("/rest/services/","/rest/admin/services/");
  // AppContext.addCors(url); // TODO???
  return url;
}

export function readServiceJson(url,target) {
  const promise = new Promise((resolve,reject) => {
    const promises = [];

    aiimUtil.readServiceJson(url).then(result => {
      //console.log("_readServiceJson",result)
      const serviceInfo = result.data;
      target.serviceInfo = serviceInfo;
      serviceInfo.layers.forEach(layer => {
        const id = layer.id;
        const p = aiimUtil.readServiceJson(url+"/"+id);
        promises.push(p);
        p.then(layerResult => {
          const layerInfo = layerResult.data;
          if (sourceUtil.hasPeopleFields(layerInfo,true)) {
            target.peopleLayerInfo = layerInfo;
          } else if (sourceUtil.hasUnitsFields(layerInfo,true)) {
            target.unitsLayerInfo = layerInfo;
          }
          // if (layerInfo.name.toLowerCase() === "people") {
          //   target.peopleLayerInfo = layerInfo;
          // } else if (layerInfo.name.toLowerCase() === "units") {
          //   target.unitsLayerInfo = layerInfo;
          // }
        });
      });
      serviceInfo.tables.forEach(table => {
        const id = table.id;
        const p = aiimUtil.readServiceJson(url+"/"+id);
        promises.push(p);
        p.then(tableResult => {
          //console.log("tableResult",tableResult)
          const tableInfo = tableResult.data;
          if (sourceUtil.hasAreasFields(tableInfo)) {
            target.areasTableInfo = tableInfo;
          }
          // if (tableInfo.name.toLowerCase() === "areas") {
          //   target.areasTableInfo = tableInfo;
          // }
        });
      });

      if (promises.length > 0) {
        return Promise.all(promises);
      }
    }).then(() => {
      resolve();
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise
}

export function validateApplyEditsResponse(response) {
  const results = response.data;
  let error = null;

  const makeError = (err) => {
    let err2 = new Error("Error applying edits");
    if (err.code) err2.code = err.code;
    if (err.message) err2.message = err.message;
    if (err.description) err2.message = err.description;
    return err2;
  };

  const check = (list) => {
    if (list) {
      list.forEach(featureResult => {
        if (featureResult.error) {
          if (!error) {
            error = makeError(featureResult.error);
          }
          if (featureResult.error.code === 1003) {
            // "Operation rolled back."
          } else {
            // throw the first error that isn't a roll back
            throw makeError(featureResult.error);
          }
        }
      });
    }
  };

  results.forEach(layerResult => {
    check(layerResult.addResults);
    check(layerResult.updateResults);
    check(layerResult.deleteResults);
  });
  if (error) throw error;
}
